import {connect} from 'react-redux'
import {getQueryAirportActionCreator} from 'data/redux/actions/guiActions';
import AirportSelector
  from 'gui/components/editors/flightEditor/components/ticketDetailsForm/components/ticketDetails/components/airportSelector';
import {IAirport} from 'data/interfaces/products';


const mapStateToProps = (state, {label, field}) => {
  return {label, field};
};


const mapDispatchToProps = (dispatch) => {
  return {
    queryAirport: (query) => dispatch(getQueryAirportActionCreator(query))
      .then((airports: IAirport[]) => {
        return airports.map(airport => ({
          label: airport.name,
          value: airport as IAirport,
        }));
      })
  };
};

const AirportSelectorContainer = connect(mapStateToProps, mapDispatchToProps)(AirportSelector);

export default AirportSelectorContainer;
